import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { removeDefaultParams } from '../../Utils/helper';
import { AgeList } from './styled';

export default function VaccinationWekkList(props) {
  const { data, key } = props;
  const router = useRouter();
  return (
    <>
      <AgeList disableList={data?.url == ''} key={`vaccinationList${key}`}>
        {data?.url == '' ? (
          'SELECT AGE'
        ) : (
          <Link
            href={{
              pathname: `/tools/vaccination/${data?.url}`,
              query: removeDefaultParams(router.query),
            }}
            passHref
            locale={false}
          >
            {data?.name}
          </Link>
        )}
      </AgeList>
    </>
  );
}
